import { Box, Button, Paper, Stack, styled, Typography } from '@mui/material';
import Layout from '@src/components/layout/Layout';

import HospitalUserForm from '../hospital-user-edit/components/HospitalUserForm';
import { useHospitalUserForm } from '../hospital-user-edit/hooks/useHospitalUserForm';
import { generatePath, Link } from 'react-router-dom';
import { Routes } from '@src/navigation/Routes';

const PREFIX = 'HospitalUserProfile';

const classes = {
  readOnlyField: `${PREFIX}-readOnlyField`,
};

const StyledLayout = styled(Layout)(({ theme }) => ({
  [`& .${classes.readOnlyField}`]: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiOutlinedInput-input': {
      typography: 'body1',
      pt: 0,
      pl: 2,
      pb: 0,
    },
  },
}));

function HospitalUserDetails() {
  const {
    control,
    register,
    roles,
    currentOrganisation,
    currentHospital,
    userSlug,
    fullName,
  } = useHospitalUserForm();

  return (
    <StyledLayout>
      <Box sx={{ margin: 'auto', width: 949, px: 2 }}>
        <Stack direction={'row'} justifyContent="space-between" mb={4}>
          <Typography variant="h4">{fullName}</Typography>

          <Button
            component={Link}
            to={generatePath(Routes.OrganisationHospitalUserEdit, {
              organisationSlug: currentOrganisation?.name ?? '',
              hospitalSlug: currentHospital?.name ?? '',
              userSlug: userSlug,
            })}
            variant="outlined"
            size="large"
            color="primary">
            Edit
          </Button>
        </Stack>

        <Paper>
          <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
            <Typography variant="h6">User details</Typography>
          </Box>

          <Box
            sx={{
              pb: 2,
            }}>
            <HospitalUserForm
              fieldClassName={classes.readOnlyField}
              register={register}
              readOnly={true}
              roles={roles}
              control={control}
            />
          </Box>
        </Paper>
      </Box>
    </StyledLayout>
  );
}

export default HospitalUserDetails;
